<template>
  <form @submit.prevent="submit">
    <h1 class="container-title" :class="[`text-${titleAlignment}`]" v-if="!hideTitle">Login</h1>
    <FormMessage :errors="errors" v-if="errors" />
    <div :class="wideLayout ? 'row' : ''">
      <FormInput
        name="email"
        v-model="loginFields.email"
        testId="email-input"
        placeholder="Email"
        label="Email *"
        :class="wideLayout ? 'col-md-6' : ''"
        :errors="validation.fields.email.errors"
        :dirty="validation.fields.email.dirty"
        :tabindex="1"
      />
      <FormPassword
        name="password"
        v-model="loginFields.password"
        type="password"
        testId="password-input"
        placeholder="Password"
        label="Password *"
        :class="wideLayout ? 'col-md-6' : ''"
        :errors="validation.fields.password.errors"
        :dirty="validation.fields.password.dirty"
        :tabindex="2"
        autocomplete="off"
      />
    </div>
    <template v-if="loginFields.twoFactorRequired">
      <div v-if="smsSent" class="text-secondary text-center form-group mt-4">
        SMS Code sent! If you do not receive a code within 5 mintes
        <a href="" target="_blank" @click.prevent="send2faSMS">Click here</a>
        to trigger another.
      </div>
      <div :class="wideLayout ? 'row' : ''">
        <FormInput
          name="two-factor-code"
          v-model="loginFields.twoFactorCode"
          testId="two-factor-code-input"
          placeholder="Authentication Code"
          label="Authentication Code *"
          :class="wideLayout ? 'col-md-6' : ''"
          :errors="validation.fields.twoFactorCode.errors"
          :dirty="validation.fields.twoFactorCode.dirty"
          :tabindex="3"
          autocomplete="off"
        />
        <div :class="wideLayout ? 'col-md-6 mt-4' : ''">
          <FormCheckbox
            name="remember-me"
            v-model="loginFields.rememberMe"
            testId="remember-me-input"
            label="Remember this device for 30 days."
            :errors="validation.fields.rememberMe.errors"
            :dirty="validation.fields.rememberMe.dirty"
            :tabindex="4"
          />
        </div>
      </div>
    </template>
    <div class="form-actions">
      <div :class="`text-${buttonAlignment}`">
        <CFTurnstileBypass v-if="useTurnstile" v-model="turnstileBypass" />
        <CFTurnstile
          v-if="useTurnstile"
          ref="turnstileContainer"
          :sitekey="turnstileSiteKey"
          :loadTurnstileScript="true"
          :tabindex="5"
          @verify="onVerify"
          @expired="onExpired"
          class="turnstile-container"
        />
        <div v-if="wideLayout" class="login-links text-start">
          <div class="forgot my-2">
            <Btn variant="link" @click="onForgotPasswordClick()" :tabindex="6">
              Forgot Password?
            </Btn>
          </div>
          <div class="sign-up my-2 tw-text-center">
            Don't have a Nexcess account?
            <BtnLink @click="onSignUpClick()" :tabindex="7">Sign Up</BtnLink>
          </div>
        </div>
        <Btn
          type="submit"
          :disabled="loading"
          :loading="loading"
          :tabindex="9"
          data-test="login-button"
          class="tw-w-full"
        >
          Login
        </Btn>
      </div>
      <div v-if="loginFields.twoFactorRequired && hasCell && !smsSent">
        <Btn variant="link" @click="send2faSMS" :tabindex="10">Authenticate via SMS</Btn>
      </div>
      <div v-if="!wideLayout" class="login-links">
        <div class="forgot my-2">
          <Btn variant="link" @click="onForgotPasswordClick()" :tabindex="11">
            Forgot Password?
          </Btn>
        </div>
        <div class="sign-up my-2 tw-text-center">
          Don't have a Nexcess account?
          <BtnLink @click="onSignUpClick()" :tabindex="12">Sign Up</BtnLink>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Btn from "@/components/display/Btn";
import BtnLink from "@/components/display/BtnLink";
import CFTurnstile from "@/components/misc/CFTurnstile/CFTurnstile";
import CFTurnstileBypass from "@/components/smart/forms/CFTurnstileBypass";
import constants from "@/utils/constants";
import { defineAsyncComponent } from "vue";
import FormCheckbox from "@/components/display/form/FormCheckbox";
import FormInput from "@/components/display/form/FormInput";
import FormMessage from "@/components/display/form/FormMessage";
import { loginSetup } from "@/utils/login";
import router from "@/router";

export default {
  name: "LoginForm",
  emits: ["success", "close"],
  components: {
    Btn,
    BtnLink,
    FormInput,
    FormCheckbox,
    FormMessage,
    FormPassword: defineAsyncComponent(() =>
      import(/* webpackChunkName: "form-password" */ "@/components/display/form/FormPassword")
    ),
    CFTurnstile,
    CFTurnstileBypass,
  },
  props: {
    forgotPasswordAction: {
      type: Function,
      default: () => {
        router.push({ name: constants.ROUTES.FORGOT_PASSWORD });
      },
    },
    signupAction: {
      type: Function,
      default: () => {
        router.push({ name: constants.ROUTES.SIGNUP });
      },
    },
    backAction: Function,
    title: String,
    titleAlignment: {
      type: String,
      default: "center",
    },
    buttonAlignment: {
      type: String,
      default: "center",
    },
    wideLayout: Boolean,
    hideTitle: Boolean,
  },
  setup: loginSetup,
};
</script>

<style lang="scss" scoped>
.login-links {
  font-size: 0.75rem;
  // text-align: center;
  .forgot {
    margin-bottom: 1rem;
  }
}
</style>
